import { Image, Result, Spin } from "antd";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { PayPalButton } from "react-paypal-button-v2";
import Logo from "../../assets/images/logo_WasteNoFood_header.gif";
import { API } from "../../config/api";
import { PostAPIRequest } from "../../services/api";
function Payment({ history }) {
  const TokenStatus = {
    Validating: "Validating",
    Valid: "Valid",
    Invalid: "Invalid",
    Success: "Success",
  };

  const [token, setToken] = useState(null);
  const [tokenStatus, setTokenStatus] = useState(TokenStatus.Validating);

  useEffect(() => {
    const { token, type } = queryString.parse(window.location.search);

    // remove token from url to prevent http referer leakage
    // history.replace(window.location.pathname);
    PostAPIRequest({
      url: API.validateResetToken,
      data: {
        token: token,
        user_type: type,
      },
    })
      .then((response) => {
        console.log("Request Successful!", response);
        if (response.status === "success") {
          setToken(token);
          setTokenStatus(TokenStatus.Valid);
        } else {
          alert(response.message);
          setTokenStatus(TokenStatus.Invalid);
        }
      })
      .catch((error) => {
        console.error("Request Failed:", error);
        setTokenStatus(TokenStatus.Invalid);
      });
  }, []);

  function getForm() {
    /*function onSubmit({ password, confirmPassword }, { setSubmitting }) {
      const { type } = queryString.parse(window.location.search);
      PostAPIRequest({
        url: API.updatePassword,
        data: {
          token: token,
          password: password,
          confirmPassword: confirmPassword,
          user_type: type,
        },
      })
        .then((response) => {
          console.log("Request Successful!", response);

          if (response.status === "success") {
            setTokenStatus(TokenStatus.Success);
            //alert("Password reset successful, you can now login");
          } else {
            setSubmitting(false);
            alert(response.message);
          }
        })
        .catch((error) => {
          setSubmitting(false);
          alert(error);
        });
    }*/

    return (
      <PayPalButton
        amount="0.01"
        catchError={(err) => {
          console.log("catchError");
          console.error(err);
        }}
        onError={(err) => {
          console.log("onError");
          console.error(err);
        }}
        onCancel={(err) => {
          console.log("onCancel");
          console.error(err);
        }}
        shippingPreference="NO_SHIPPING"
        onSuccess={(details, data) => {
          alert("Transaction completed by " + details.payer.name.given_name);

          // OPTIONAL: Call your server to save the transaction
          /*return fetch("/paypal-transaction-complete", {
            method: "post",
            body: JSON.stringify({
              orderID: data.orderID,
            }),
          });*/
        }}
      />
    );
  }

  function subscriptions() {
    return (
      <PayPalButton
        options={{ vault: true }}
        createSubscription={(data, actions) => {
          return actions.subscription.create({
            plan_id: "P-4FT4682904066221XMDAFDYY",
          });
        }}
        onApprove={(data, actions) => {
          // Capture the funds from the transaction
          return actions.subscription.get().then(function (details) {
            // Show a success message to your buyer
            alert("Subscription completed");

            // OPTIONAL: Call your server to save the subscription
            return fetch("/paypal-subscription-complete", {
              method: "post",
              body: JSON.stringify({
                orderID: data.orderID,
                subscriptionID: data.subscriptionID,
              }),
            });
          });
        }}
        catchError={(err) => {
          console.log("catchError");
          console.error(err);
        }}
        onError={(err) => {
          console.log("onError");
          console.error(err);
        }}
        onCancel={(err) => {
          console.log("onCancel");
          console.error(err);
        }}
      />
    );
  }

  function addSub() {
    return (
      <PayPalButton
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  currency_code: "USD",
                  value: "0.01",
                },
              },
            ],
            // application_context: {
            //   shipping_preference: "NO_SHIPPING" // default is "GET_FROM_FILE"
            // }
          });
        }}
        onApprove={(data, actions) => {
          // Capture the funds from the transaction
          return actions.order.capture().then(function (details) {
            // Show a success message to your buyer
            alert("Transaction completed by " + details.payer.name.given_name);

            // OPTIONAL: Call your server to save the transaction
            return fetch("/paypal-transaction-complete", {
              method: "post",
              body: JSON.stringify({
                orderID: data.orderID,
              }),
            });
          });
        }}
      />
    );
  }

  function getBody() {
    switch (tokenStatus) {
      case TokenStatus.Valid:
        return subscriptions();
      case TokenStatus.Invalid:
        return (
          <Result
            status="500"
            title="Token validation failed!"
            subTitle="Token validation failed, if the token has expired you can get a new
            one at the forgot password page."
          />
        );
      case TokenStatus.Validating:
        return (
          <>
            <Result title="Validating token... Please Wait.." />
            <Spin size="large" />
          </>
        );
      case TokenStatus.Success:
        return (
          <Result
            status="success"
            title="Thank You!"
            subTitle="Password reset successful, you can now login!"
          />
        );
    }
  }

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: 400,
          maxWidth: 500,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image style={{ marginTop: 40, marginBottom: 30 }} src={Logo} />
        <div style={{ alignSelf: "stretch", marginTop: 40, marginBottom: 30 }}>
          {getBody()}
        </div>
      </div>
    </div>
  );
}

export default Payment;
